import axios from 'axios';
import apiConfig from '../api.config';

export default function getMailTemplates({ hotelId }) {
  const {
    host,
    URIs: { mailTemplates },
  } = apiConfig;

  const uri = `${host}${mailTemplates}`.replace(':hotelId', hotelId);

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
